import { useEffect, useState } from "react";
import styles from "./VenueHero.module.css";

import img1 from "./images/411421409.webp";
import img2 from "./images/620719916.webp";
import img3 from "./images/hilton-bangalore-embassy.webp";
import img4 from "./images/hotels-banner.webp";
import img5 from "./images/img409-scaled.webp";
import img6 from "./images/itc-maurya.webp";
import img7 from "./images/KOLKA-P0159-Hotel-Exterior-Front-Drive-Evening.16x9.webp";
import img8 from "./images/Screenshot-2025-02-05-at-15.07.26-500x500-c-default.webp";



const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
];
export default function VenueHero() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className={styles.hero}>
      {images.map((image, index) => (
        <div
          key={image}
          className={`${styles.slide} ${
            current === index ? styles.active : ""
          }`}
          style={{
            backgroundImage: `url(${image})`,
          }}
        />
      ))}

      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <h1>
          Discover Premium Hotels &
          <br />
          Ballrooms Across India
        </h1>

        <p>
          Explore hotels, compare ballrooms, capacities,
          dimensions and venue specifications for your next event.
        </p>
      </div>
    </section>
  );
}